import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import DiversityInclusion from '../Components/diversity/DiversityInclusion'
import FocusAreasSection from '../Components/diversity/FocusAreasSection'
import MobikodeRiseSection from '../Components/diversity/MobikodeRiseSection'
import { Helmet } from "react-helmet-async";

function Diversity() {
    return (
        <div>
            <Helmet>
    <title>
        Diversity & Inclusion | Building an Inclusive Workplace | Mobikode
    </title>

    <meta
        name="description"
        content="Discover Mobikode's commitment to diversity and inclusion, creating an inclusive workplace where different perspectives, backgrounds, and experiences are welcomed and valued."
    />

    <meta
        name="keywords"
        content="Mobikode Diversity and Inclusion, Diversity & Inclusion, Workplace Diversity, Inclusive Workplace, Diversity in Technology, Inclusion at Workplace, Employee Inclusion, Equal Opportunity Workplace, Inclusive Culture, Workplace Belonging, Mobikode Culture, Diversity Initiatives"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/diversity-inclusion"
    />

    <meta
        property="og:title"
        content="Diversity & Inclusion | Building an Inclusive Workplace | Mobikode"
    />

    <meta
        property="og:description"
        content="Learn how Mobikode promotes diversity, inclusion, belonging, and equal opportunities to create a workplace where everyone can contribute and grow."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/diversity-inclusion"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/diversity/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Diversity & Inclusion | Building an Inclusive Workplace | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's approach to diversity and inclusion and our commitment to building a welcoming, inclusive, and supportive workplace."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/diversity/bg1.png"
    />
</Helmet>
            <WhoHero
                title="Diversity & Inclusion"
                text="The different. The difference. We welcome both."
                imgData="/assets/diversity/bg1.png"
            />
            <DiversityInclusion />
            <FocusAreasSection />
            <MobikodeRiseSection />
        </div>
    )
}

export default Diversity
